module.exports = __webpack_public_path__ + "img/spouse.19076b71.svg";